import React from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";

import { Box, Button, Grid, Text, ErrorMsg } from "atoms";
import { FormInput } from "molecules/FormInput";
import { useNavigate } from "react-router-dom";

const validationSchema = Yup.object().shape({
  email: Yup.string().email().required(),
  password: Yup.string().required(),
});

export const LoginForm = ({ onSubmit, loading, error, resetError }) => {
  const navigate = useNavigate();

  return (
    <Box>
      <Text
        fontSize="2rem"
        color="primary.900"
        fontFamily="NeometricBold"
        mb="3.2rem"
      >
        Log in
      </Text>

      <Formik
        initialValues={{
          email: "",
          password: "",
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({ setFieldValue }) => {
          return (
            <Form>
              <Grid gridGap="2.4rem">
                <FormInput
                  name="email"
                  type="text"
                  placeholder="Email*"
                  onChange={(e) => {
                    setFieldValue("email", e?.target?.value);
                    error && resetError();
                  }}
                />
                <FormInput
                  name="password"
                  type="password"
                  placeholder="Password"
                  onChange={(e) => {
                    setFieldValue("password", e?.target?.value);
                    error && resetError();
                  }}
                />
                {error && <ErrorMsg text={error} />}
                <Button
                  my="2rem"
                  width="100%"
                  variant="primary"
                  height="4.8rem"
                  loading={loading}
                >
                  Log In
                </Button>
              </Grid>
            </Form>
          );
        }}
      </Formik>
      <Box>
        <Text
          fontSize="1.6rem"
          color="neutral.800"
          fontFamily="NeometricMedium"
          textAlign="center"
        >
          Forgot Password? &nbsp;
          <Text
            as="span"
            color="secondary.700"
            cursor="pointer"
            onClick={() => navigate("/send-email")}
          >
            Request Reset Link
          </Text>
        </Text>
      </Box>
    </Box>
  );
};
